import React from "react";

import { Theme } from "@material-ui/core";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { changeColorBrightness } from "@qpr/client-api-base/utils/color";
const useStyles = makeThemedStyles("ProgressBar", (theme: Theme) => {
  return {
    container: {
      border: "1px solid #E2E3E3",
      position: "relative",
      height: "36px",
      borderRadius: "35px",
      width: "100%",
    },
    barContainer: {
      width: "calc(100% - 6px)",
      position: "absolute",
      height: "28px",
      top: "3px",
      left: "50%",
      marginLeft: "calc(-50% + 3px)", // -48.5%
      borderRadius: "35px",
      overflow: "hidden",
      zIndex: 1,
      boxShadow: "-3px 3px 6px var(--rangeColor)",
    },
    text: {
      display: "flex",
      textAlign: "center",
      width: "100%",
      fontSize: "16px",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      fontWeight: 500,
      zIndex: 2,
    },
    progressBar: {
      height: "100%",
      borderRadius: "50px",
      opacity: 0.9,
      position: "relative",
      width: "100%",
    },
    notText: {
      color: "#fff !important",
    },
  };
});

const PercentageBar = (props: {
  value: number;
  color?: string | null;
  textClassName?: string;
  displayText?: string;
  disableAnimation?: boolean;
  rtl?: boolean;
}) => {
  const classes = useStyles();
  const barWidthInit = props.value > 0 ? props.value : 0;
  const barWidth = barWidthInit > 100 ? 100 : barWidthInit;
  const color = `${props.color ? props.color : "#878889"}`;
  const darkerColor = changeColorBrightness(color, 0.72);
  return (
    <div
      className={classes.container}
      style={{ "--rangeColor": `${color}30` } as any}
    >
      <div
        className={classes.barContainer}
        style={{
          background:
            props.value < 0 ||
            props.value === undefined ||
            Number.isNaN(props.value)
              ? `linear-gradient(90deg, rgba(88,92,96,1) 48%, rgba(135,136,137,1) 88%)`
              : `${color}40`,
        }}
      >
        <div
          className={classes.progressBar}
          style={{
            background: `linear-gradient(${
              props.rtl ? `to left` : "to right"
            },${color} 0%, ${color} ${(100 - barWidth).toFixed(
              0
            )}%, ${color}60 100%`,
            transform: props.rtl
              ? `translateX(${101 - barWidth}%)`
              : `translateX(${barWidth - 101}%)`,
          }}
        />
      </div>
      <div
        className={`${classes.text} ${
          props.textClassName ? props.textClassName : ""
        } ${
          props.value < 0 ||
          props.value === undefined ||
          Number.isNaN(props.value)
            ? classes.notText
            : ""
        }`}
        style={{ color: darkerColor }}
      >
        <div>
          <div
            style={{ position: "relative", zIndex: 3, whiteSpace: "nowrap" }}
          >
            {props.value < 0 ||
            props.value === undefined ||
            Number.isNaN(props.value)
              ? "-"
              : props.rtl
              ? props.displayText
                ? props.displayText
                : `%${props.value.toFixed(0)}`
              : props.displayText
              ? props.displayText
              : `${props.value.toFixed(0)}%`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PercentageBar;
